// extracted by mini-css-extract-plugin
module.exports = {"userSlogan":"MeProfileStatus_userSlogan__K4dL4","editStatusInput":"MeProfileStatus_editStatusInput__3-uK_","setStatusButton":"MeProfileStatus_setStatusButton__1EG9o"};